// extracted by mini-css-extract-plugin
export default {"wrapper":"Face_style_wrapper__Oo5on","content":"Face_style_content__Cp7GM","rotate":"Face_style_rotate__EvMjZ"};